<div>
    <ui-page-title [inModal]="true" [pageCode]="pageCode" [showModalHeader]="true" [title]="'' | translate"></ui-page-title>
    <div class="pb-6 pt-3">
        <div class="col-12">
            <div class="search-container">
                <p-accordion>
                    <p-accordionTab [header]="'searchCriteria' | translate" [selected]="true">
                        <position-picker-search-form
                            [showDate]="showDate"
                            [form]="form"
                            (onSearch)="onSearch()"

                            [isClear]="isClear"
                            (onBack)="isClear = false"
                        ></position-picker-search-form>
                        <ui-advance-search-footer-buttons [form]="form" [checkFormIsValid]="true" (onClear)="onClear()" (onSearch)="onSearch()"
                                                          [idPrefix]="pageCode"></ui-advance-search-footer-buttons>
                    </p-accordionTab>
                </p-accordion>
            </div>
        </div>
        <div class="col-12">
            <p-table
                [id]="pageCode + '_list'"
                dataKey="{{dataKey}}"
                selectionMode="single"
                styleClass="p-datatable-striped"
                [value]="tableList"
                [lazy]="true"
                (onLazyLoad)="lazyLoadData($event)"
                [paginator]="true"
                [rows]="10"
                [rowsPerPageOptions]="[10, 20, 50]"
                [totalRecords]="totalElements"
                [loading]="loading"
                [(selection)]="selectedItem"
                [selectionMode]="selectionMode"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th pFrozenColumn *ngIf="selectionMode && selectionMode !== 'single'" style="width: 45px">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th id="beginDate" pSortableColumn="beginDate">
                            {{ 'hrPerCommon.beginDate' | translate }}
                            <p-sortIcon field="beginDate"></p-sortIcon>
                        </th>
                        <th id="endDate" pSortableColumn="endDate">
                            {{ 'hrPerCommon.endDate' | translate }}
                            <p-sortIcon field="endDate"></p-sortIcon>
                        </th>
                        <th id="objectNumber" pSortableColumn="objectNumber">
                            {{ 'hrPerPosition.objectNumber' | translate }}
                            <p-sortIcon field="objectNumber"></p-sortIcon>
                        </th>
                        <th id="objectCode" pSortableColumn="objectCode">
                            {{ 'hrPerPosition.positionCode' | translate }}
                            <p-sortIcon field="objectCode"></p-sortIcon>
                        </th>
                        <th id="longText" pSortableColumn="longText">
                            {{ 'hrPerPosition.position' | translate }}
                            <p-sortIcon field="longText"></p-sortIcon>
                        </th>
                        <th id="degreeOfCadre" pSortableColumn="degreeOfCadree">
                            {{ 'hrPerPosition.degreeOfCadre' | translate }}
                            <p-sortIcon field="degreeOfCadree"></p-sortIcon>
                        </th>
                        <th id="managerialPosition" pSortableColumn="managerialPosition">
                            {{ 'hrPerPosition.managerPosition' | translate }}
                            <p-sortIcon field="managerialPosition"></p-sortIcon>
                        </th>
                        <th id="singleIncubentPosition" pSortableColumn="singleIncubentPosition">
                            {{ 'hrPerPosition.singleIncubentPosition' | translate }}
                            <p-sortIcon field="singleIncubentPosition"></p-sortIcon>
                        </th>
                        <th id="countCapacity">
                            {{ 'hrPerPosition.countCapacity' | translate }}
                        </th>
                        <th id="status" pSortableColumn="objectStatusId">
                            {{ 'hrPerPosition.status' | translate }}
                            <p-sortIcon field="objectStatusId"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-it>
                    <tr [pSelectableRow]="it">
                        <td pFrozenColumn *ngIf="selectionMode && selectionMode !== 'single'" style="width: 45px">
                            <p-tableCheckbox [value]="it" [pSelectableRow]="it"></p-tableCheckbox>
                        </td>
                        <td>{{ it.beginDate | dateConvert }}</td>
                        <td>{{ it.endDate | dateConvert }}</td>
                        <td>{{ it.objectNumber }}</td>
                        <td>{{ it.objectCode }}</td>
                        <td>{{ it.longText }}</td>
                        <td>{{ it.degreeOfCadree }}</td>
                        <td>{{ (it.managerialPosition ? 'hrPerCommon.booleanTrue' : 'hrPerCommon.booleanFalse') | translate }}</td>
                        <td>{{ (it.singleIncubentPosition ? 'hrPerCommon.booleanTrue' : 'hrPerCommon.booleanFalse') | translate }}</td>
                        <td>{{ it.capacityPosition + '/' + it.countCapacity}}</td>
                        <td>{{ it.objectStatusText }}</td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="5">{{ 'noRecordsFound' | translate }}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
    <ui-sticky-buttonbar>
        <div class="mr-2">
            <button [id]="pageCode + '_cancel'" (click)="onCancel()" [label]="'button.cancel' | translate" class="p-button-text" pButton></button>
        </div>
        <div>
            <button [id]="pageCode + '_select'" (click)="onRowSelectClickEvent()" [label]="'addSelected' | translate" pButton></button>
        </div>
    </ui-sticky-buttonbar>
</div>
